import { useContext } from 'react';
import type { PropertyPreviewVisibilityScopeProps } from '../types/property-preview.type';
import { PropertyPreviewVisibilityContext } from './property-preview-visibility-context';

/**
 * Disables preview registrations immediately when an expanded column collapses.
 * @param props - Expanded column content and its current visibility.
 * @returns Descendants under the combined parent/column visibility state.
 */
export const PropertyPreviewVisibilityScope = ({
  active,
  children,
}: PropertyPreviewVisibilityScopeProps) => {
  const parentActive = useContext(PropertyPreviewVisibilityContext);
  return (
    <PropertyPreviewVisibilityContext.Provider value={parentActive && active}>
      {children}
    </PropertyPreviewVisibilityContext.Provider>
  );
};
